// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".agreement-container[data-v-43eda57d] {\n  margin: 25px;\n  background: #fff;\n}\n.mobile-agreement-container[data-v-43eda57d] {\n  background: #fff;\n  border-radius: 20px;\n  padding: 30px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
